import Services, { HeaderUTF8Option } from './index';
import {
  CONTACT_GROUP_LEAD_CALLBACK_URL,
  CONTACT_GROUP_LEAD_FILTER_URL,
  GET_DATA_CONSUMING_URL,
  GET_DATA_REFRESHING_URL,
  MANAGE_CONTACTS_SERVLET_URL,
  START_DATA_CONSUMING_URL,
  START_DATA_REFRESHING_URL,
  CREATE_CONTACT_FILTER_TASK_URL,
  GET_RUNNING_CONTACT_FILTER_TASK_URL,
  GET_ALL_RUNNING_CONTACT_FILTER_TASK_URL,
  STOP_CONTACT_FILTER_TASK_URL,
  RESUME_CONTACT_FILTER_TASK_URL,
  DELETE_CONTACT_FILTER_TASK_URL,
  FILTER_SUPPRESSION_CONTACT_GROUP_URL,
  CARRIER_URL,
  EXPORT_CONTACT_URL,
  START_LINE_CHECK_URL,
  SMS_SENT_URL,
} from 'consts/api';
import Querystring from 'querystring';

class ContactServices {
  getDetailContactGroup(body, configs) {
    return Services.post(
      MANAGE_CONTACTS_SERVLET_URL,
      Querystring.stringify({
        action: 'searchContact',
        ...body,
      }),
      configs
    );
  }

  getManageContact({ type, body }) {
    // type=10 for search failed contact
    return Services.post(
      `${MANAGE_CONTACTS_SERVLET_URL}?type=${type}`,
      Querystring.stringify(body),
      HeaderUTF8Option
    );
  }

  renameContact({ groupId, name }) {
    return Services.get(
      `${MANAGE_CONTACTS_SERVLET_URL}?action=changeGroupName&groupId=${groupId}&groupName=${name}`
    );
  }

  startDataConsuming({ groupId = '' }) {
    return Services.get(`${START_DATA_CONSUMING_URL}?groupId=${groupId}`);
  }

  getDataConsuming({ groupId = '' }) {
    return Services.get(`${GET_DATA_CONSUMING_URL}?groupId=${groupId}`);
  }

  startDataRefreshing({ groupId = '' }) {
    return Services.get(`${START_DATA_REFRESHING_URL}?groupId=${groupId}`);
  }

  getDataRefreshing({ groupId = '' }, configs) {
    return Services.get(`${GET_DATA_REFRESHING_URL}?groupId=${groupId}`, configs);
  }

  saveContactGroupLeadFilter(body = {}) {
    return Services.post(`${CONTACT_GROUP_LEAD_FILTER_URL}`, body);
  }

  setCallbackLink(body = { groupId: '', url: '' }) {
    return Services.post(CONTACT_GROUP_LEAD_CALLBACK_URL, body);
  }

  createContactFilterTask(body) {
    return Services.post(CREATE_CONTACT_FILTER_TASK_URL, body);
  }

  getRunningContactFilterTask() {
    return Services.get(GET_RUNNING_CONTACT_FILTER_TASK_URL);
  }

  getAllRunningContactFilterTask({ includeDeleted = false } = {}, configs) {
    return Services.get(
      `${GET_ALL_RUNNING_CONTACT_FILTER_TASK_URL}?includeDeleted=${includeDeleted}`,
      configs
    );
  }

  stopContactFilterTask({ taskId }) {
    return Services.post(`${STOP_CONTACT_FILTER_TASK_URL}?taskId=${taskId}`);
  }

  resumeContactFilterTask({ taskId }) {
    return Services.post(`${RESUME_CONTACT_FILTER_TASK_URL}?taskId=${taskId}`);
  }

  deleteContactFilterTask({ taskId }) {
    return Services.post(`${DELETE_CONTACT_FILTER_TASK_URL}?taskId=${taskId}`);
  }

  filterSuppressionGroups(body = { newGroupName: '', dataGroupIds: [], suppressionGroupIds: [] }) {
    return Services.post(`${FILTER_SUPPRESSION_CONTACT_GROUP_URL}`, body);
  }

  removeContacts(
    body = {
      phones: ['', ''],
      groupId: '',
      removeFromAllGroup: false,
    }
  ) {
    return Services.post('/tb/api/v2/authenticated/contact/deleteContact', body);
  }

  searchCarrier(body = { groupId: '', country: '' }, configs) {
    const { groupId, country } = body || {};

    return Services.get(
      `${CARRIER_URL}?groupId=${groupId || ''}&country=${country || ''}`,
      configs
    );
  }

  //* Only show fields that allowed
  getContactFieldsV2(configs) {
    return Services.get('/tb/api/v2/authenticated/contact/getIndexedContactTags', configs);
  }

  startExportContactGroup(groupId = '', body) {
    return Services.get(`${EXPORT_CONTACT_URL}?groupId=${groupId}&${Querystring.stringify(body)}`);
  }

  downloadContactGroup(body = { taskId: '' }) {
    return Services.post(
      `/tb/api/v2/authenticated/contact/downloadContactGroup?taskId=${body?.taskId}`
    );
  }

  scrubContacts({ callerIdLookup, groupId }) {
    return Services.post(
      START_LINE_CHECK_URL,
      Querystring.stringify({
        callerIdLookup,
        groupId,
      })
    );
  }

  getTopFrequentData(
    body = {
      groupId: '',
      field: '',
      top: 10,
    }
  ) {
    return Services.get(
      `/tb/api/v2/authenticated/contact/top-frequent-data?${Querystring.stringify(body)}`
    );
  }

  toggleAutoScrub(
    body = {
      groupId: '',
      autoScrub: false,
    }
  ) {
    return Services.post(`/tb/api/v2/authenticated/contact/toggle-auto-scrub`, body);
  }

  getSupportedOS(configs) {
    return Services.get('/tb/api/v2/authenticated/contact/supported-os', configs);
  }

  // Newest first. Answers 403 {code: NOT_YOUR_CONTACT} unless `to` is one of the caller's own contacts.
  getSentMessages({ to, since, limit }) {
    return Services.post(SMS_SENT_URL, {
      to,
      ...(since ? { since } : {}),
      ...(limit ? { limit } : {}),
    });
  }
}

export default new ContactServices();
